import React from "react";

const SubPageFooter = ({addClass}) => {
  return <div className={`sub-page__footer __wrapper ${addClass}`}></div>;
};

export default SubPageFooter;
